import PropTypes from "prop-types";
import React from "react";

import EditRouteForm from "v2/components/responsive/EditRouteForm";
import ModalLink from "v2/components/responsive/ModalLink";

const EditRouteLink = (props, context) => {
  const {params: {date, routeId}} = context;
  return (
    <ModalLink
      form={EditRouteForm}
      label="Edit Route"
      url={`/${date}/${routeId}/edit`}
      {...props} />
  );
};

EditRouteLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default EditRouteLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/EditRouteLink.js
 **/